export default "__VITE_ASSET__BbKUbi_O__"